<template>
  <b-form-group class="ml-4">
    <label>
      <b>
        {{ $t('date_format') }}
      </b>
      <span :id="$id('strptimehelp')" class="fas fa-question-circle" />

      <b-popover :target="$id('strptimehelp')" placement="righttop">
        <b-table small :items="datetime_strptime_formats"></b-table>
      </b-popover>
    </label>

    <draggable
      v-model="local_date_formats"
      class="drag-area ml-1"
      group="new_date_formats"
      handle=".select-col-handle"
    >
      <b-badge
        v-for="(format, index) in local_date_formats"
        :key="format"
        pill
        variant="primary"
        class="pr-1 select-col-handle hand-pointer mr-1"
      >
        {{ format }}
        <span
          class="fas fa-times-circle ml-1 finger-pointer"
          @click="local_date_formats.splice(index, 1)"
        />
      </b-badge>
    </draggable>
    <b-row class="mt-2">
      <b-col cols="6">
        <b-input-group>
          <b-form-input
            v-model="curr_format"
            :placeholder="$t('enter_date_format')"
          />
          <b-btn variant="outline-secondary" @click="add_curr_format"
            ><span class="fas fa-plus"
          /></b-btn>
        </b-input-group>
      </b-col>
    </b-row>
  </b-form-group>
</template>

<i18n>
{
  "en": {
    "date_format": "Date format",
    "enter_date_format": "Please enter the date format"
  },
  "fr": {
    "date_format": "Format de date",
    "enter_date_format": "Entrez le format de date"
  }
}
</i18n>

<script>
import _ from 'lodash'
import draggable from 'vuedraggable'

import { tagid_mixin } from '@/components/mixin.js'

// *****************************************************************************

export default {
  name: 'CoercionDateFormats',
  components: { draggable },
  mixins: [tagid_mixin],
  props: ['value'],
  data() {
    return {
      uid: _.uniqueId('tokensub'),
      curr_format: '',
      local_date_formats: [],
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.local_date_formats = _.cloneDeep(nv)
        }
      },
    },

    local_date_formats(nv) {
      this.$emit('input', nv)
    },
  },

  methods: {
    add_curr_format() {
      if (
        this.curr_format !== '' &&
        _.indexOf(this.local_date_formats, this.curr_format) === -1
      ) {
        this.local_date_formats.push(this.curr_format)
        this.curr_format = ''
      }
    },
    datetime_strptime_formats() {
      let headers = ['Directive', 'Meaning', 'Example']
      let formats = [
        '%w',
        'Weekday as a decimal number, where 0 is Sunday and 6 is Saturday.',
        '0, 1, …, 6',
        '%d',
        'Day of the month as a zero-padded decimal number.',
        '01, 02, …, 31',
        '%m',
        'Month as a zero-padded decimal number.',
        '01, 02, …, 12',
        '%y',
        'Year without century as a zero-padded decimal number.',
        '00, 01, …, 99',
        '%Y',
        'Year with century as a decimal number.',
        '1970, 1988, 2001, 2013',
        '%H',
        'Hour (24-hour clock) as a zero-padded decimal number.',
        '00, 01, …, 23',
        '%I',
        'Hour (12-hour clock) as a zero-padded decimal number.',
        '01, 02, …, 12',
        '%M',
        'Minute as a zero-padded decimal number.',
        '00, 01, …, 59',
        '%S',
        'Second as a zero-padded decimal number.',
        '00, 01, …, 59',
        '%f',
        'Microsecond as a decimal number, zero-padded on the left.',
        '000000, 000001, …, 999999',
        '%z',
        'UTC offset in the form +HHMM or -HHMM (empty string if the the object is naive).',
        '(empty), +0000, -0400, +1030',
        '%Z',
        'Time zone name (empty string if the object is naive).',
        '(empty), UTC, EST, CST',
        '%j',
        'Day of the year as a zero-padded decimal number.',
        '001, 002, …, 366',
        '%U',
        'Week number of the year (Sunday as the first day of the week) as a zero padded decimal number. All days in a new year preceding the first Sunday are considered to be in week 0.',
        '00, 01, …, 53',
        '%W',
        'Week number of the year (Monday as the first day of the week) as a decimal number. All days in a new year preceding the first Monday are considered to be in week 0.',
        '00, 01, …, 53',
        '%%',
        "A literal '%' character.",
        '%',
      ]
      let res = []
      for (let contents of _.chunk(formats, 3)) {
        res.push(_.zipObject(headers, contents))
      }
      return res
    },
  },
}
</script>
